var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6.07 9c0 1.6 1.31 2.9 2.93 2.9 1.61 0 2.92-1.3 2.92-2.9 0-1.6-1.31-2.9-2.92-2.9A2.92 2.92 0 0 0 6.07 9Zm7.23-4.47c1.28 1 2.37 2.44 3.16 4.25.05.14.05.3 0 .43C14.89 12.83 12.1 15 9 15c-3.1 0-5.89-2.17-7.46-5.79a.55.55 0 0 1 0-.43C3.11 5.16 5.9 3 9 3H9c1.55 0 3.02.54 4.3 1.53ZM9 10.81c1 0 1.82-.82 1.82-1.81a1.82 1.82 0 0 0-2.08-1.8 1.5 1.5 0 0 1-1.5 1.44h-.03A1.82 1.82 0 0 0 9 10.81Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye18);
export default __webpack_public_path__ + "static/media/eye-18.cf9a53e9d14e4df209577912b6874bee.svg";
export { ForwardRef as ReactComponent };